module.exports = __webpack_public_path__ + "img/qrcode-app.b94fdb66.png";